module.exports = __webpack_public_path__ + "img/nabl_gallery13.28d87fc1.jpg";